import { createTheme } from '@mui/material/styles';
var theme = createTheme({
    palette: {
        primary: {
            extraLight: '#d1c4e9',
            light: '#9575cd',
            main: '#673ab7',
            dark: '#4527a0',
            extraDark: '#311b92',
        },
        secondary: {
            extraLight: '#eceff1',
            light: '#90a4ae',
            main: '#607d8b', //#183153
            dark: '#455a64',
            extraDark: '#263238',
        },
        warning: {
            extraLight: '#FEEACD',
            light: '#ffb74d',
            main: '#ff9800',
            dark: '#f57c00',
            extraDark: '#A85500',
        },
        tertiary: {
            extraLight: '#C3E6E3',
            light: '#A6CEC8',
            main: '#4DB6AC',
            dark: '#3A8D85',
            extraDark: '#2C7A7A',
        },
        info: {
            extraLight: '#D4EAFC',
            light: '#64b5f6',
            main: '#2B5186',
            dark: '#1976d2',
            extraDark: '#035291',
        },
        success: {
            extraLight: '#CBE7CC',
            light: '#81c784',
            main: '#4caf50',
            dark: '#388e3c',
            extraDark: '#245626',
        },
        text: {
            primary: '#2B2B2B', // Mine Shaft Grey
            secondary: '#757575',
            disabled: '#bdbdbd',
        },
        grey: {
            50: '#FAFAFA',
            100: '#F5F5F5',
            200: '#EEEEEE',
            300: '#E0E0E0',
            400: '#BDBDBD',
            500: '#9E9E9E',
            600: '#757575',
            700: '#616161',
            800: '#424242',
            900: '#212121',
        },
    },
    typography: {
        h1: {
            fontSize: '2.225rem',
            '@media (max-width:600px)': {
                fontSize: '1.75rem',
            },
        },
        h2: {
            fontSize: '1.85rem',
            '@media (max-width:600px)': {
                fontSize: '1.5rem',
            },
        },
        h3: {
            fontSize: '1.6rem',
            '@media (max-width:600px)': {
                fontSize: '1.25rem',
            },
        },
        h4: {
            fontSize: '1.35rem',
            '@media (max-width:600px)': {
                fontSize: '1rem',
            },
        },
        h5: {
            fontSize: '1.1rem',
            '@media (max-width:600px)': {
                fontSize: '0.875rem',
            },
        },
        h6: {
            fontSize: '0.975rem',
            '@media (max-width:600px)': {
                fontSize: '0.75rem',
            },
        },
        body1: {
            fontSize: '1.1rem',
            fontWeight: 400,
            lineHeight: 1.23, // had to change back
            '@media (max-width:600px)': {
                fontSize: '0.875rem',
            },
        },
        body2: {
            fontSize: '0.975rem',
            fontWeight: 400,
            lineHeight: 1.57,
            '@media (max-width:600px)': {
                fontSize: '0.75rem',
            },
        },
        subtitle1: {
            fontSize: '1.1rem',
            fontWeight: 400,
            lineHeight: 1.75,
            '@media (max-width:600px)': {
                fontSize: '0.875rem',
            },
        },
        subtitle2: {
            fontSize: '0.975rem',
            fontWeight: 500,
            lineHeight: 1.57,
            '@media (max-width:600px)': {
                fontSize: '0.75rem',
            },
        },
        caption: {
            fontSize: '0.85rem',
            fontWeight: 400,
            lineHeight: 1.66,
            '@media (max-width:600px)': {
                fontSize: '0.625rem',
            },
        },
        overline: {
            fontSize: '0.85rem',
            fontWeight: 400,
            lineHeight: 2.66,
            '@media (max-width:600px)': {
                fontSize: '0.625rem',
            },
        },
        button: {
            fontSize: '0.975rem',
            fontWeight: 500,
            lineHeight: 1.75,
            '@media (max-width:600px)': {
                fontSize: '0.75rem',
            },
        },
        fontFamily: [
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
});
export default theme;
